import type { RootState } from 'features/app/store/store';

export const notificationSelector = ({ notification }: RootState) =>
  notification;
